module.exports = __webpack_public_path__ + "static/tina-56641703da0bf3cdc352a5f525b5ef43.jpg";